import React, { PureComponent } from "react";
import DocumentTitle from "react-document-title";
import QRCode from "qrcode";
import { Modal } from "antd-mobile";
import { connect } from "react-redux";
import { actions } from "@/store/actions/result";
import ShadeTip from "@/components/ShadeTip";
import BasicInfo from "./components/BasicInfo";
import ChartInfo from "./components/ChartInfo";
import BottomCard from "./components/BottomCard";
import ShareHeader from "./components/ShareHeader";
import {
  Constants,
  DEFAULT_TEXT,
  SPEED_APP_SCHEME,
  SPEED_H5_LINK,
  DEFAULT_FROM,
} from "@/const/result";
import { splineOptions } from "@/utils/chartOptions";
import {
  isPC,
  browser,
  isWeixin,
  parseQueryInUrl,
  setHtmlClass,
} from "@/utils/utils";
import { setShareConfig } from "@/utils/share";
import {
  jsOpenShareDialog,
  jsOpenPage,
  configWebPageInfo,
} from "@/utils/bridge";
import styles from "@/css/result.module.less";
// import VConsole from "vconsole";

// new VConsole();

const speedTransfer = (speed) => {
  let re = DEFAULT_TEXT;
  if (speed === DEFAULT_TEXT) return re;
  if (Number(speed) === 0) {
    re = "0M";
  } else if (speed > 0 && speed < 2) {
    re = "0~2M";
  } else if (speed >= 2 && speed < 5) {
    re = "2~5M";
  } else if (speed >= 5 && speed < 10) {
    re = "5~10M";
  } else if (speed >= 10 && speed < 20) {
    re = "10~20M";
  } else if (speed >= 20 && speed < 50) {
    re = "20~50M";
  } else if (speed >= 50 && speed < 100) {
    re = "50~100M";
  } else if (speed >= 100 && speed < 200) {
    re = "100~200M";
  } else if (speed >= 200 && speed < 300) {
    re = "200~300M";
  } else if (speed >= 300 && speed < 500) {
    re = "300~500M";
  } else if (speed >= 500 && speed < 1000) {
    re = "500~1000M";
  } else {
    re = "1000M以上";
  }
  return re;
};

// const rocketPosition = (speed) => {
//   let re = "0%";
//   if (speed === DEFAULT_TEXT) return re;
//   const isPCEnv = isPC();
//   let extraVal = 0;
//   if (speed === 0) {
//     extraVal = isPCEnv ? 2 : 0;
//     re = `${3 + extraVal}%`;
//   } else if (speed > 0 && speed < 10) {
//     extraVal = isPCEnv ? 2 : 0;
//     re = `${10 + extraVal}%`;
//   } else if (speed >= 10 && speed < 20) {
//     extraVal = isPCEnv ? 2 : 0;
//     re = `${20 + extraVal}%`;
//   } else if (speed >= 20 && speed < 50) {
//     extraVal = isPCEnv ? 3 : 0;
//     re = `${30 + extraVal}%`;
//   } else if (speed >= 50 && speed < 100) {
//     extraVal = isPCEnv ? 4 : 0;
//     re = `${40 + extraVal}%`;
//   } else if (speed >= 100 && speed < 200) {
//     extraVal = isPCEnv ? 4 : 0;
//     re = `${55 + extraVal}%`;
//   } else if (speed >= 200 && speed < 500) {
//     extraVal = isPCEnv ? 6 : 0;
//     re = `${75 + extraVal}%`;
//   } else {
//     extraVal = isPCEnv ? 8 : 0;
//     re = `${95 + extraVal}%`;
//   }
//   return re;
// };

class AppResult extends PureComponent {
  constructor(props) {
    super(props);
    this.speedId = this.props.match.params.speedId;
    this.query = parseQueryInUrl(this.props.location.search);

    this.state = {
      percent: "0%",
      isp: "",
      delay: 0,
      downloadSpeed: 0,
      uploadSpeed: 0,
      downloadLineOptions: splineOptions(
        { backgroundColor: "#2A2F3B " },
        "app"
      ),
      uploadLineOptions: splineOptions({ backgroundColor: "#2A2F3B " }, "app"),
      showTip: false,
      // 判断页面是从哪里进入的
      from: DEFAULT_FROM,
      isAndroid: true,
      documentTitle: "",
      downloadQrcode: "",
    };
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    this.parseUrl();
    setHtmlClass(styles["init-css"]);
    configWebPageInfo({
      module: "module:dashboard",
      page_name: "page:result",
    });
  };

  getDownloadQrcode = (from = "share", speedId = "0") => {
    if (!isPC()) return;
    QRCode.toDataURL(
      `${window.location.origin}/result/${speedId}?from=${from}&type=scan`,
      (err, url) => {
        this.setState({
          downloadQrcode: url,
        });
      }
    );
  };

  parseUrl = () => {
    const {
      location: { search },
    } = this.props;
    const searchObj = parseQueryInUrl(search);
    console.log("searchObj: ", searchObj);
    if (searchObj.from) {
      this.setState({
        from: searchObj.from || DEFAULT_FROM,
      });
    }
    // this.getDownloadInfo(searchObj.from);
    this.initTestSpeedInfo(this.speedId);
    this.getDownloadQrcode(searchObj.from, this.speedId);
  };

  initTestSpeedInfo = (speedId) => {
    const callback = (result) => {
      console.log("result: ", result);
      const arrLength =
        Math.min(
          result.downloadSpeedCurve.length,
          result.uploadSpeedCurve.length
        ) - 1;
      this.setState({
        percent: result.percent,
        isp: result.isp,
        delay: result.delay,
        documentTitle: result.clientIp
          ? result.clientIp.replace(/(\d{1,3})$/, "*")
          : "",
        downloadSpeed: result.download,
        uploadSpeed: result.upload,
        downloadLineOptions: {
          series: [
            {
              color: Constants.NEW_DOWNLOAD_COLOR,
              data: result.downloadSpeedCurve.splice(0, arrLength - 1),
            },
          ],
        },
        uploadLineOptions: {
          series: [
            {
              color: Constants.NEW_UPLOAD_COLOR,
              data: result.uploadSpeedCurve.splice(0, arrLength - 1),
            },
          ],
        },
      });
    };
    const payload = {
      speedId,
    };
    this.props.querySpeedTestResultInfo({ payload, callback });
  };

  transferMb = (speedArr) => {
    if (speedArr && speedArr.length > 0) {
      speedArr.forEach((item, index, arr) => {
        arr[index] = item / 1024 / 1024;
      });
    }
    return speedArr;
  };

  // getDownloadInfo = (from) => {
  //   if (!from || from !== "share") return;
  //   // 只有分享的时候才需要知道下载信息
  //   const isAndroid = browser("android");
  //   const isIOS = browser("ios");
  //   this.setState({
  //     isAndroid,
  //   });
  //   const isFromScan = this.query.type && this.query.type === "scan";
  //   if (isAndroid) {
  //     const origin = "1";
  //     const callback = () => {
  //       // 如果是扫描进入的，自动打开app
  //       if (isFromScan) {
  //         console.log("scan");
  //         this.handleOpenApp();
  //       }
  //     };
  //     this.props.queryDownloadInfo({
  //       payload: { origin, flavor: 1 },
  //       callback,
  //     });
  //   } else if (isIOS) {
  //     if (isFromScan) {
  //       console.log("scan");
  //       this.jumpToSpeedH5();
  //     }
  //   }
  // };

  jumpToSpeedH5 = () => {
    window.location.href = SPEED_H5_LINK;
  };

  handleOpenApp = () => {
    const { isAndroid } = this.state;
    if (isAndroid) {
      if (isWeixin()) {
        this.setState({
          showTip: true,
        });
        return;
      }
      const {
        data: { downloadInfo },
      } = this.props;
      const downloadUrl = (downloadInfo && downloadInfo.downloadUrl) || "#";
      const wait = 3000;
      const isFromScan = this.query.type && this.query.type === "scan";
      let hidden = false;
      // 尝试打开APP
      window.location.href = SPEED_APP_SCHEME;
      const messageEl = (
        <p>
          是否未安装APP？
          <br />
          点击确定按钮下载APP
        </p>
      );
      setTimeout(() => {
        console.log("hidden:", hidden);
        if (!hidden) {
          console.log("没有安装APP");
          // 如果是扫描进来的，就自动下载
          if (isFromScan) {
            window.location.href = downloadUrl;
            return;
          }
          // 如果是手动点击进来的，提示是否下载
          Modal.alert("提示", messageEl, [
            { text: "取消" },
            {
              text: "确定",
              onPress: () => {
                window.location.href = downloadUrl;
              },
            },
          ]);
        }
      }, wait);
      // 监听页面状态是否切换来判断是否自动打开APP
      document.addEventListener("visibilitychange", function () {
        console.log("visibilitychange");
        console.log("document.hidden: ", document.hidden);
        if (document.hidden) {
          hidden = true;
        }
      });
    } else {
      this.jumpToSpeedH5();
    }
  };

  testAgain = () => {
    console.log("调用原生方法，再试一次");
    jsOpenPage({
      url: "page:home?index=0&autoStart=true",
    });
  };

  shareTestResult = () => {
    console.log("调用原生方法，进行分享");
    const { percent } = this.state;
    const share_config = setShareConfig({
      share_link: `${window.location.origin}/app-result/${this.speedId}?from=share`,
      percent,
    });
    jsOpenShareDialog(share_config);
  };

  formatSpeed = (speed) => {
    if (speed >= 0 && speed < 10) return speed.toFixed(2);
    if (speed >= 10 && speed < 100) return speed.toFixed(1);
    if (speed >= 100) return speed.toFixed(0);
    return DEFAULT_TEXT;
  };

  hideShadeTip = () => {
    this.setState({
      showTip: false,
    });
  };

  render() {
    const {
      isp,
      delay,
      downloadSpeed,
      uploadSpeed,
      uploadLineOptions,
      downloadLineOptions,
      showTip,
      from,
      percent,
      documentTitle,
      downloadQrcode,
    } = this.state;
    const isFromShare = from === "share";
    const basicInfo = {
      isp,
      percent,
      realSpeed: speedTransfer(this.formatSpeed(downloadSpeed)),
      rocketPosition: percent,
    };
    console.log("basicInfo: ", basicInfo);
    const netInfo = {
      delay,
      downloadSpeed: this.formatSpeed(downloadSpeed),
      uploadSpeed: this.formatSpeed(uploadSpeed),
      uploadLineOptions,
      downloadLineOptions,
    };
    console.log("netInfo: ", netInfo);
    const shareInfo = {
      percent,
      speedId: this.speedId,
      downloadQrcode,
    };
    return (
      <DocumentTitle
        title={isFromShare ? `用户${documentTitle}的测速报告` : "测速详情"}
      >
        <div
          className={`${styles["result-page"]} ${
            !isFromShare ? "" : styles["with-header"]
          }`}
        >
          {isFromShare && <ShareHeader handleBtnClickCb={this.handleOpenApp} />}
          <BasicInfo data={basicInfo} />
          <ChartInfo data={netInfo} />
          <BottomCard
            from={from}
            info={shareInfo}
            clickCallback={this.handleOpenApp}
          />
          {showTip && <ShadeTip clickCallBack={this.hideShadeTip} />}
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = ({ result }) => {
  return {
    data: result,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // queryDownloadInfo: (data) => dispatch(actions.getDownloadInfo(data)),
  querySpeedTestResultInfo: (data) => {
    dispatch(actions.getSpeedTestResultInfo(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppResult);
